import { FormControlLabel, Checkbox, FormControl, FormHelperText } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { AgeLimit as AgeLimitEnum, FormatVersion, ReviewSection, ReviewTarget } from '~/generated/graphql'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { z } from 'zod'

export const ageLimitSchemaFields = {
  ageLimit: z.enum([AgeLimitEnum.NoLimit, AgeLimitEnum.OverTwenties]),
}
export const ageLimitSchema = z.object(ageLimitSchemaFields)

// キャンペーンの対象年齢を確認する
export const AgeLimit = ({ description }: CampaignInputComponentProps) => {
  const { control } = useFormContext<z.infer<typeof ageLimitSchema>>()
  return (
    <CampaignInputComponent
      title=""
      required={false}
      description={description}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.AgeLimit],
      }}
    >
      <Controller
        control={control}
        name="ageLimit"
        render={({ field: { ref, onChange, value, ...field } }) => (
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  defaultChecked={value === AgeLimitEnum.OverTwenties}
                  name="ageLimit"
                  inputRef={ref}
                  onChange={(_, checked) => onChange(checked ? AgeLimitEnum.OverTwenties : AgeLimitEnum.NoLimit)}
                  checked={value === AgeLimitEnum.OverTwenties}
                />
              }
              label="20歳未満のインフルエンサーを応募対象から外す"
            />
            <FormHelperText sx={{ ml: 0 }}>
              ※20歳未満に提供できないサービス（アルコール等）の場合はチェックを付けてください。
            </FormHelperText>
          </FormControl>
        )}
      />
    </CampaignInputComponent>
  )
}
